import { PAYMENT_STATUS } from 'domains/fast-sell-payment/constants'

/**
 *
 * @param {number} fastSellProductId - id of the fast sell product
 * @param {object} seller - seller object to prefill the fields when creating
 * @param {number} lastPriceOffer - the last price offer to prefill the amount when creating
 * @returns
 */
const fastSellPaymentFormInitialValues = ({ fastSellProduct }) => {

  const { seller, payment, price_offers } = fastSellProduct
  const lastIndex                         = price_offers?.length -1
  let lastPriceOffer                      = price_offers&[ lastIndex ]

  // need to update lastPriceOffer due to price_offers&[ lastIndex ] resulting 0
  if (price_offers)
    lastPriceOffer = price_offers[ lastIndex ]

  const today       = new Date().toISOString().substr(0, 10)
  const paymentDate = payment && new Date(payment?.transferred_at)?.toISOString().substr(0, 10)

  return ({
    id                       : payment?.id || '',
    fast_sell_product_id     : fastSellProduct?.id || '',
    credit_bank_account_no   : payment?.credit_bank_account_no || seller?.account_number || '',
    transferred_at           : paymentDate || today,
    credit_bank_branch       : payment?.credit_bank_branch || seller?.bank_branch || '',
    credit_bank_name         : payment?.credit_bank_name || seller?.bank || '',
    credit_bank_account_name : payment?.credit_bank_account_name || seller?.account_name || '',
    debit_bank               : payment?.debit_bank || '',
    amount                   : payment?.amount || lastPriceOffer?.price || '',
    payment_status           : payment?.payment_status || PAYMENT_STATUS.PENDING
  })
}


export default fastSellPaymentFormInitialValues
